import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './index.module.scss'
import { useState } from 'react';
import Spotlight from '../../global/Spotlight/Spotlight';

// Kata kunci populer — tiap chip membuka Spotlight dengan query yang sudah terisi
const POPULAR_SEARCHES = [
    { label: 'Matematika', query: 'matematika' },
    { label: 'Bahasa Indonesia', query: 'bahasa indonesia' },
    { label: 'Bahasa Inggris', query: 'bahasa inggris' },
    { label: 'Pancasila', query: 'pancasila' },
    { label: 'Buku Audio', query: 'audio' },
]

const Hero = ({ nightMode }) => {

    // Handle night mode
    let backgroundColor = nightMode ? 'bg-night' : 'bg-soft-blue'
    let titleColor = nightMode ? 'text-white' : 'text-blue'
    let descColor = nightMode ? 'text-white' : 'text-dark'
    let vector = nightMode ? '/assets/image/home/aset home night.png' : '/assets/image/home/aset home day.png'

    const [openSpotlight, setOpenSpotlight] = useState(false)
    const [searchSeed, setSearchSeed] = useState('')

    const openSearch = (seed = '') => {
        setSearchSeed(seed)
        setOpenSpotlight(true)
    }

    return (
        <section id="hero" className={`${backgroundColor} position-relative ${styles.hero}`}>
            {/* ── Section-level background ornaments ── */}
            <img src="/assets/image/home/ellipse-1.png" alt="" aria-hidden="true"
                className={`position-absolute ${styles.float}`}
                style={{ top: '-2%', right: '0', width: '110px', opacity: 0.65, pointerEvents: 'none', zIndex: 0 }} />
            <img src="/assets/image/home/ellipse-3.png" alt="" aria-hidden="true"
                className={`position-absolute ${styles['float-down']}`}
                style={{ bottom: '-2%', left: '0', width: '95px', opacity: 0.55, pointerEvents: 'none', zIndex: 0, animationDelay: '1s' }} />
            <img src="/assets/image/home/Group 76.png" alt="" aria-hidden="true"
                className={`position-absolute d-none d-lg-block ${styles['float-right']}`}
                style={{ top: '18%', left: '1%', width: '52px', opacity: 0.38, pointerEvents: 'none', zIndex: 0, animationDelay: '0.4s' }} />
            <img src="/assets/image/home/Group 80.png" alt="" aria-hidden="true"
                className={`position-absolute d-none d-lg-block ${styles.float}`}
                style={{ bottom: '14%', left: '3%', width: '45px', opacity: 0.32, pointerEvents: 'none', zIndex: 0, animationDelay: '2s' }} />
            <div className="container p-3">
                <div className="row">
                    <div className="col-lg-6 order-last order-md-first my-3 my-md-auto">
                        <h1 className={`${styles['title-hero']} ${titleColor} fw-bold`}>Buku untuk Semua</h1>
                        <p className={`lead ${descColor}`}>Akses <div className="d-inline-flex flex-column"><span>di mana pun, kapan pun,</span><span className="mt-n3 d-none d-md-block"><img src="/assets/image/home/line-title.png" alt="line title" /></span></div> Baca buku yuk!</p>
                        {/* Spotlight-style search trigger */}
                        <button
                            type="button"
                            onClick={() => openSearch()}
                            className={`${styles.searchTrigger} w-100 mt-5`}
                            aria-label="Buka pencarian buku"
                        >
                            <FontAwesomeIcon icon={faSearch} className={styles.searchTriggerIcon} />
                            <span className={styles.searchTriggerText}>Cari buku disini</span>
                            <span className="search-cta">Cari</span>
                        </button>
                        {/* Pencarian populer */}
                        <div className={`${styles.popularRow} ${nightMode ? styles.nightMode : ''}`}>
                            <span className={styles.popularLabel}>Pencarian populer:</span>
                            {POPULAR_SEARCHES.map((item) => (
                                <button
                                    key={item.query}
                                    type="button"
                                    className={styles.popularChip}
                                    onClick={() => openSearch(item.query)}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                        <Spotlight open={openSpotlight} setOpen={setOpenSpotlight} initialQuery={searchSeed} />
                    </div>
                    <div className="col-lg-6 d-flex align-items-center justify-content-center py-2">
                        {/* ── Right-column ornaments ── */}
                        <img src="/assets/image/home/Hearts.png" alt="" aria-hidden="true"
                            className={`position-absolute ${styles.float}`}
                            style={{ top: '2%', left: '4%', width: '50px', opacity: 0.8, pointerEvents: 'none', zIndex: 2, animationDelay: '0.8s' }} />
                        <img src="/assets/image/home/Group 20.png" alt="" aria-hidden="true"
                            className={`position-absolute ${styles.pulsate}`}
                            style={{ top: '4%', right: '4%', width: '44px', opacity: 0.65, pointerEvents: 'none', zIndex: 2, animationDelay: '0.3s' }} />
                        <img src="/assets/image/home/Group 22.png" alt="" aria-hidden="true"
                            className={`position-absolute ${styles['float-down']}`}
                            style={{ bottom: '4%', right: '3%', width: '40px', opacity: 0.6, pointerEvents: 'none', zIndex: 2, animationDelay: '1.2s' }} />
                        <img src="/assets/image/home/ellipse-2.png" alt="" aria-hidden="true"
                            className={`position-absolute ${styles.float}`}
                            style={{ bottom: '2%', left: '6%', width: '58px', opacity: 0.5, pointerEvents: 'none', zIndex: 0, animationDelay: '1.6s' }} />
                        <img src="/assets/image/home/Group 21.png" alt="" aria-hidden="true"
                            className={`position-absolute ${styles.rotate}`}
                            style={{ top: '32%', left: '1%', width: '30px', opacity: 0.4, pointerEvents: 'none', zIndex: 0, animationDelay: '0s' }} />
                        {/* ── Video ── */}
                        <div className="ratio ratio-16x9 w-100 rounded-4 shadow-lg overflow-hidden" style={{ position: 'relative', zIndex: 1 }}>
                            <iframe
                                src="https://www.youtube.com/embed/eb1T-lkR9qw"
                                title="Video Pengenalan Pejabat"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                        {/* ── Vector mascot floating near video ── */}
                        <img src={vector} alt="" aria-hidden="true"
                            className={`position-absolute d-none d-lg-block ${styles['float-down']}`}
                            style={{ bottom: '-10%', right: '-4%', width: '135px', pointerEvents: 'none', zIndex: 2, animationDelay: '0.6s' }} />
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Hero
